import { cx } from '@emotion/css';
import { useContext } from 'react';

import { ToggleState } from '../../../hooks';
import { GlobalHeaderContext } from '../GlobalHeaderContext';
import {
  dotBottomLeftCss,
  dotBottomRightCss,
  dotContainerCss,
  dotCss,
  dotsGroupContainerCss,
  dotTopLeftCss,
  dotTopRightCss,
} from './GlobalHeaderAnimatedIcon.styles';

export const GlobalHeaderAnimatedIcon = () => {
  const { screenState } = useContext(GlobalHeaderContext);

  return (
    <div
      className={cx(dotsGroupContainerCss, {
        expanded: screenState === ToggleState.TURNING_ON || screenState === ToggleState.ON,
        collapsed: screenState === ToggleState.TURNING_OFF,
      })}
    >
      <div className={dotContainerCss}>
        <div className={cx('dot', dotCss, dotTopLeftCss)} />
      </div>
      <div className={dotContainerCss}>
        <div className={cx('dot', dotCss, dotTopRightCss)} />
      </div>
      <div className={dotContainerCss}>
        <div className={cx('dot', dotCss, dotBottomLeftCss)} />
      </div>
      <div className={dotContainerCss}>
        <div className={cx('dot', dotCss, dotBottomRightCss)} />
      </div>
    </div>
  );
};
